<button mat-button
  *ngIf="menu.show && menu?.children && menu?.children.length > 0"
  [matMenuTriggerFor]="menu_button" [disabled]="!menu.enable">{{ menu.text
  }}</button>
<button mat-button
  *ngIf="menu.show && (!menu?.children || menu?.children.length === 0)"
  [disabled]="!menu.enable" (click)="navigateTo(menu.routerLink)">{{ menu.text
  }}</button>

<mat-menu #menu_button="matMenu">
  <ng-container *ngFor="let m of menu?.children">
    <button *ngIf="m.show && (!m.children || m.children.length === 0)"
      [disabled]="!m.enable"
      mat-menu-item
      (click)="navigateTo(m.routerLink)">
      {{ m.text }}
    </button>

    <app-sub-menu-up-bar2
      *ngIf="m.show && m.children && m.children.length > 0"
      [menu]="m">
    </app-sub-menu-up-bar2>
  </ng-container>
</mat-menu>
